export default class ItemMenuModel {
    id = Date.now();
    title = "";
    url = "";
    itemList = [];
    isNew = true;
}
  